// Pages a Batch action link opens without a login, msk-eu only. The backend builds each link as
// <web checkout signup URL>/<path>#<alias> (web_path in kaia-backend's ActionTokens::PURPOSES),
// and the page validates the alias for its purpose.
export const UPLOAD_PRESCRIPTION_PAGE = Object.freeze({
  path: 'upload-prescription',
  purpose: 'prescription_upload',
  routeName: 'upload-prescription',
})

export const REQUEST_PRESCRIPTION_PAGE = Object.freeze({
  path: 'request-prescription',
  purpose: 'doctor_outreach',
  routeName: 'request-prescription',
})

export const ACTION_LINK_PAGES = Object.freeze([
  UPLOAD_PRESCRIPTION_PAGE,
  REQUEST_PRESCRIPTION_PAGE,
])

// Case-insensitive like vue-router, so a hand-edited path still gets its alias captured.
export const findActionLinkPage = (pathname) => {
  const normalized = pathname.replace(/\/$/, '').toLowerCase()
  return ACTION_LINK_PAGES.find(({ path }) => normalized.endsWith(`/${path}`))
}

export const isActionLinkRouteName = (routeName) =>
  ACTION_LINK_PAGES.some((page) => page.routeName === routeName)

// The initial navigation is async, so a route name is still missing the first time the app reads
// it. The startup path is already known, and an action link page must not be treated as any other
// page for even that moment.
export const routeNameOrStartupPage = (routeName) =>
  routeName ?? findActionLinkPage(window.location.pathname)?.routeName ?? null
